import { motion } from 'framer-motion';
// material
import { styled } from '@mui/material/styles';
import { Typography, Container, Grid, Theme, useTheme, Stack, Box } from '@mui/material';
import { varWrapEnter } from '../../animate';
import { NextIcon } from '../../NextIcon';
import { SxProps } from '@mui/system';

// ----------------------------------------------------------------------

const RootStyle = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  width: '100%',
  height: '100%'
}));

// ----------------------------------------------------------------------

export interface LandingCardsPostProps {
  title?: string;
  cards: CardProps[];
  sx?: SxProps;
}

interface ImgProps {
  theme: Theme;
  src: string;
}

const Img = styled(motion.div)(({ theme, src }: ImgProps) => ({
  borderRadius: theme.shape.borderRadius,
  backgroundImage: `linear-gradient(to top, #161C24 6.88%, rgba(22, 28, 36, 0.01) 70.52%),url('${src}')`,
  backgroundSize: 'cover',
  objectFit: 'cover',
  backgroundRepeat: 'no-repeat',
  height: '453px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    height: '65vh'
  }
}));

const ImgText = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  top: '60%',
  width: '90%',
  margin: 'auto',
  color: theme.palette.common.white
}));

const Enlace = styled(motion.a)(({ theme }) => ({
  minWidth: '5em',
  minHeight: 20,
  color: theme.palette.primary.main,
  textDecoration: 'none'
}));
interface CardProps {
  name: string;
  date: string;
  to: string;
  icon: string;
  rate: number;
  comment: string;
}

export default function LandingCardsPost({ title, cards, sx }: LandingCardsPostProps) {
  const theme = useTheme();
  return (
    <RootStyle sx={sx} initial="initial" animate="animate" variants={varWrapEnter}>
      <Container maxWidth={'lg'}>
        <Typography
          sx={{
            textAlign: 'center',
            display: {
              xl: 'block',
              lg: 'block',
              md: 'block',
              sm: 'none',
              xs: 'none'
            }
          }}
          variant={'h2'}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
            display: {
              xl: 'none',
              lg: 'none',
              md: 'none',
              sm: 'block',
              xs: 'block'
            }
          }}
          variant={'h4'}
        >
          {title}
        </Typography>
        <Box sx={{ margin: '5em' }} />
        <Grid container spacing={2}>
          {cards.map((card, index) => (
            <Grid key={index} item sm={12} xs={12} md={4} lg={4} xl={4}>
              <Img theme={theme} key={index} src={card.icon}>
                <ImgText>
                  <Stack spacing={3}>
                    <Typography
                      sx={{
                        minHeight: 20
                      }}
                      variant={'caption'}
                    >
                      {card.date}
                    </Typography>
                    <Typography variant={'body1'}>{card.name}</Typography>
                    <Stack direction={'row'}>
                      <Enlace href={card.to} target={'_blank'}>
                        {card.comment}
                      </Enlace>
                      <NextIcon />
                    </Stack>
                  </Stack>
                </ImgText>
              </Img>
            </Grid>
          ))}
        </Grid>
      </Container>
    </RootStyle>
  );
}
